import 'css-chunksrc/client/pages/projectPage/wbsPage/sort/styles.scss';export default {
  "sort": "_sort_pw2n2_1",
  "label": "_label_pw2n2_9",
  "input": "_input_pw2n2_15",
  "placeholder": "_placeholder_pw2n2_31",
  "icon": "_icon_pw2n2_39",
  "listRoot": "_listRoot_pw2n2_47",
  "list": "_list_pw2n2_47",
  "item": "_item_pw2n2_63",
  "option": "_option_pw2n2_76",
  "selected": "_selected_pw2n2_83",
  "opened": "_opened_pw2n2_96"
};